import * as React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";

export default function EventCard(props) {
  return (
    <Card sx={{ display: "flex" }}>
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <CardMedia
          component="img"
          sx={{ width: 151 }}
          image={props.details.img}
          alt={props.details.title}
        />
        <CardContent sx={{ flex: "1 0 auto" }}>
          <Typography component="div" variant="h5">
            {props.details.title}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {props.details.description}
          </Typography>
        </CardContent>
      </Box>
    </Card>
  );
}
